<template>
  <b-container>
    <div v-if="isCompanyAdmin">
      <h1 v-translate>Company Area</h1>
      <hr>
      <div class="row">
        <div class="col-md-3">
          <company-navigation />
        </div>
        <div class="col-md-9 personal-info">
          <h3 v-translate>Manage Integrations</h3>
          <form role="company-admin-form">
            <b-row class="col-12" v-if="$frontConfig.platforms && $frontConfig.platforms.length > 0">
              <integration-card
                v-for="platformDefinition in platformDefinitions"
                :key="platformDefinition.id"
                :platform="platformDefinition"
                :platforms="platforms"
                v-if="$frontConfig.platforms && platforms.length > 0 && $frontConfig.platforms.indexOf(platformDefinition.slug) !== -1"
              ></integration-card>
            </b-row>
            <b-alert variant="info" show v-else>
              <h4 class="mb-0" v-translate>There are no available integrations in your country yet but we are already working on it :)</h4>
            </b-alert>
          </form>
        </div>
      </div>
    </div>
    <div v-else>
      <h1 v-translate>Manage Integrations</h1>
      <hr>
      <div class="row">
        <div class="col-12 personal-info">
          <form role="normal-form">
            <b-row class="col-12" v-if="$frontConfig.platforms && $frontConfig.platforms.length > 0">
              <integration-card
                v-for="platformDefinition in platformDefinitions"
                :key="platformDefinition.id"
                :platform="platformDefinition"
                :platforms="platforms"
                v-if="$frontConfig.platforms && platforms.length > 0 && $frontConfig.platforms.indexOf(platformDefinition.slug) !== -1"
              ></integration-card>
            </b-row>
            <b-alert variant="info" show v-else>
              <h4 class="mb-0" v-translate>There are no available integrations in your country yet but we are already working on it :)</h4>
            </b-alert>
          </form>
        </div>
      </div>
    </div>
  </b-container>
</template>
<script>
import { FETCH_PROFILE } from '@/store/actions.type'
import CompanyNavigation from '@/components/CompanyNavigation'
import IntegrationCard from '@/components/IntegrationCard'
export default {
  name: 'CompanyIntegrationsPage',
  title() {
    return this.$gettext('Integrations')
  },
  components: {
    CompanyNavigation,
    IntegrationCard
  },
  data() {
    return {
      platforms: [],
      userPlatforms: [],
      platformDefinitions: [
        {
          slug: 'meli',
          name: 'Mercado Envíos FLEX',
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000374878-integraci%C3%B3n-mercado-libre-flex',
          // description: this.$gettext('Mercado Envíos FLEX Integration description lorem ipsum dolor sit amet...'),
          href: 'https://auth.mercadolibre%countryDomain%/authorization?response_type=code&client_id=%appId%&state=%state%',
          logo: '/static/img/logo-meli.svg',
          delete: 'self'
        },
        {
          slug: 'meli-v2',
          name: 'Mercado Libre v2',
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000374878-integraci%C3%B3n-mercado-libre-flex',
          to: '/profile/meli-v2/integration',
          logo: '/static/img/logo-meli.svg',
          microserviceIntegration: true,
          microserviceUninstall: { integration: 'meli-v2', path: 'v2/meli/auth/uninstall' },
          delete: 'self'
        },
        {
          slug: 'tienda-nube',
          name: 'Tiendanube',
          // description: this.$gettext('Tienda Nube Integration description lorem ipsum dolor sit amet...'),
          href: 'https://www.tiendanube.com/apps/%appId%/authorize?state=%state%',
          logo: '/static/img/logo-tienda-nube.svg',
          delete: 'external',
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000374874-integraci%C3%B3n-tiendanube'
        },
        {
          slug: 'shopify-v2',
          name: 'Shopify v2',
          to: '/shopify-v2/authenticate',
          logo: '/static/img/logo-shopify.svg',
          delete: 'external',
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000374902-integraci%C3%B3n-shopify',
          microserviceIntegration: true
        },
        {
          slug: 'woocommerce',
          name: 'WooCommerce',
          // description: this.$gettext('WooCommerce Plugin description lorem ipsum dolor sit amet...'),
          logo: '/static/img/logo-woocommerce.svg',
          delete: 'self',
          manageWebhook: true,
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000374258-integraci%C3%B3n-woocommerce-moova',
          downloadUrl: 'https://wordpress.org/plugins/moova-for-woocommerce/'
        },
        {
          slug: 'magento1',
          name: 'Magento 1',
          // description: this.$gettext('Magento 1 Plugin description lorem ipsum dolor sit amet...'),
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000374900-integraci%C3%B3n-magento-1',
          logo: '/static/img/logo-magento1.svg',
          delete: 'self'
        },
        {
          slug: 'magento2',
          name: 'Magento 2',
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000374898-integraci%C3%B3n-magento-2',
          // description: this.$gettext('Magento 2 Plugin description lorem ipsum dolor sit amet...'),
          logo: '/static/img/logo-magento2.svg',
          delete: 'self'
        },
        {
          slug: 'prestashop',
          name: 'PrestaShop',
          // description: this.$gettext('PrestaShop Plugin description lorem ipsum dolor sit amet...'),
          logo: '/static/img/logo-prestashop.svg',
          delete: 'self',
          manageWebhook: true,
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000374901-integraci%C3%B3n-prestashop',
          downloadUrl: 'https://github.com/moovaio/eCommerce-Prestashop/releases/latest'
        },
        {
          slug: 'vtex',
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000374911-integraci%C3%B3n-con-vtex',
          name: 'Vtex',
          to: '/vtex/settings',
          microserviceIntegration: true,
          // description: this.$gettext('Vtex Plugin description lorem ipsum dolor sit amet...'),
          logo: '/static/img/logo-vtex.svg',
          delete: 'self'
        },
        {
          slug: 'fenicio',
          name: 'Fenicio',
          logo: '/static/img/logo-fenicio.svg',
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000374914-integraci%C3%B3n-con-fenicio',
          delete: 'self'
        },
        {
          slug: 'glamit',
          name: 'Glamit',
          href: '/profile/glamit/integration',
          logo: '/static/img/logo-glamit.svg',
          delete: 'external'
        },
        {
          slug: 'billowshop',
          name: 'Billowshop',
          logo: '/static/img/logo-billowshop.svg',
          delete: 'self'
        },
        {
          slug: 'aper',
          name: 'Aper',
          logo: '/static/img/logo-aper.svg',
          to: '/profile/aper/integration',
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000664968-integraci%C3%B3n-con-aper',
          delete: 'self',
          microserviceIntegration: true
        },
        {
          slug: 'jumpseller',
          name: 'Jumpseller',
          helpUrl: 'https://ayuda.moova.io/es/support/solutions/articles/70000664980-integración-jumpseller',
          microserviceIntegration: true,
          logo: '/static/img/logo-jumpseller.svg',
          href: `https://accounts.jumpseller.com/oauth/authorize?client_id=%appId%&redirect_uri=${this.$appConfig.staticBaseUrl}profile/jumpseller/integration&response_type=code&scope=read_hooks write_hooks read_store write_store read_fulfillments write_fulfillments read_shipping_methods write_shipping_methods read_orders write_orders`,
          delete: 'self'
        },
        {
          slug: 'pow',
          name: 'Pow',
          helpUrl: 'https://ayuda.moova.io/support/solutions/articles/70000664970-integraci%C3%B3n-pow',
          logo: '/static/img/logo-pow.svg',
          delete: 'self',
          manageWebhook: true
        },
        {
          slug: 'multivende',
          name: 'Multivende',
          logo: '/static/img/logo-multivende.svg',
          href: 'https://app.multivende.com/apps/authorize?response_type=code&client_id=369859453353',
          microserviceIntegration: true,
          delete: 'self'
        },
        {
          slug: 'dac',
          name: 'dac',
          helpUrl: 'https://ayuda.moova.io/es/support/solutions/articles/70000665097-integración-con-dac',
          logo: '/static/img/logo-dac.svg',
          microserviceIntegration: true,
          to: '/profile/dac/integration',
          delete: 'self'
        }
      ]
    }
  },
  created() {
    this.$store.dispatch(FETCH_PROFILE)
      .then(() => {
        this.fetchPlatforms()
      })
  },
  mounted() {
    this.fetchUserPlatforms()
  },
  methods: {
    fetchPlatforms() {
      this.$http.get(this.$appConfig.api.baseUrl + 'platforms')
        .then(response => {
          this.platforms = response.body.data
        })
    },
    fetchUserPlatforms() {
      this.$http.get(this.$appConfig.api.baseUrl + 'users/' + this.$store.getters.profile.id + '/platforms')
        .then(response => {
          this.userPlatforms = response.body.data.map(x => {
            const r = x
            r.slug = x.platform.slug
            return r
          })
        })
    }
  }
}
</script>
